import { PopoverBodyLiteIcons } from '../../constants/popover';
import PopoverBodyLiteBase from '../PopoverBodyLiteBase';
import LinkPreview from './LinkPreview';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `RichTextLib.links.lite.${key}`;
function EditLinkPopoverBodyLite({
  href,
  linkDisplayName,
  linkType,
  onAnchorPreviewClick,
  onEdit,
  onUnlink
}) {
  const iconButtons = [{
    iconName: PopoverBodyLiteIcons.EDIT,
    onClick: onEdit
  }, {
    iconName: PopoverBodyLiteIcons.UNLINK,
    onClick: onUnlink
  }];
  return /*#__PURE__*/_jsx(PopoverBodyLiteBase, {
    "data-test-id": "edit-link-popover-body-lite",
    iconButtons: iconButtons,
    i18nKey: i18nKey,
    children: href && /*#__PURE__*/_jsx(LinkPreview, {
      href: href,
      linkDisplayName: linkDisplayName,
      linkType: linkType,
      onAnchorPreviewClick: onAnchorPreviewClick
    })
  });
}
EditLinkPopoverBodyLite.displayName = 'EditLinkPopoverBodyLite';
export default EditLinkPopoverBodyLite;